import { useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { FaBackward } from "react-icons/fa";
import Logo from "../assest/l.png";
import { caLogin } from "../utils/api";
import { useAuth } from "../utils/authContext";

const CaLogin = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [isCoFounder, setIsCoFounder] = useState(false);
    const { loginStartup } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess(false);

        try {
            const data = await caLogin(email, password);

            // Store user data
            localStorage.setItem("caId", data.user.id);
            localStorage.setItem("email", data.user.email);
            localStorage.setItem("role", data.user.role);
            localStorage.setItem("catoken", data.token);
            loginStartup(data.token);

            setSuccess(true);
            setTimeout(() => navigate("/ticket-interface"), 1500);
        } catch (err) {
            console.error(err);
            setError(err.message || "Something went wrong. Please try again later.");
        }
    };

    const handleToggle = () => {
        setIsCoFounder((prev) => !prev);
        if (!isCoFounder) navigate("/cofounder-login");
    };

    return (
        <div className="relative w-full h-[100dvh] lg:h-screen bg-gradient-to-br from-red-500 via-red-300 to-yellow-100 flex items-center justify-center p-4 overflow-hidden">
            {/* Logo */}
            <div className="absolute top-10 left-10">
                <Link to="/">
                    <img src={Logo} alt="Tactos Logo" className="w-20" />
                </Link>
            </div>

            {/* Auth Card */}
            <div className="w-full h-full bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
                <div className="md:w-1/2 w-full px-8 py-6 h-full flex flex-col justify-center items-center">
                    <h2 className="text-3xl font-bold text-center text-gray-800 mt-4 mb-6">
                        Welcome Back
                    </h2>

                    {success ? (
                        <div className="text-center mt-6">
                            <h3 className="text-2xl font-semibold text-green-600 mb-4">🎉 Login Successful!</h3>
                            <p className="text-gray-600 mb-4">Redirecting to your dashboard...</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-5 text-sm w-full lg:w-1/2 mx-auto">
                            {error && (
                                <motion.div initial={{ y: -10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.2 }} className="bg-red-100 text-red-700 p-3 rounded text-sm">
                                    {error}
                                </motion.div>
                            )}

                            <div className="flex flex-col">
                                <label htmlFor="email" className="text-gray-700 font-medium mb-1">Email Address</label>
                                <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none" placeholder="Your Email" />
                            </div>

                            <div className="flex flex-col">
                                <label htmlFor="password" className="text-gray-700 font-medium mb-1">Password</label>
                                <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none" placeholder="Your Password" />
                            </div>

                            <button type="submit" className="w-full px-6 py-2 bg-[#4b154c] text-white rounded-full hover:bg-purple-700 text-sm">Login</button>

                            <div className="flex justify-center mb-6 text-gray-600 text-sm">
                                Don't have an account? <Link to="/startup-reg" className="text-indigo-600 hover:underline ml-1">Sign up</Link>
                            </div>
                        </form>
                    )}
                </div>

                <div className="md:w-1/2 hidden lg:block relative overflow-hidden">
                    <img src="/register.png" alt="Startup Illustration" className="w-full lg:h-full object-cover" />
                    <Link to="/" className="absolute top-4 right-4 flex items-center gap-2 text-white"><FaBackward /> Back to Home</Link>
                </div>
            </div>
        </div>
    );
};

export default CaLogin;
